import { render, staticRenderFns } from "./attends.vue?vue&type=template&id=5da7e3e8&"
import script from "./attends.vue?vue&type=script&lang=js&"
export * from "./attends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports